import { makeStyles } from '@mui/styles'
import { useTheme } from '@mui/material/styles'
import common from 'shared/styles'

const useStyles = makeStyles(() => {
    const theme = useTheme()

    return {
        actions: {
            ...common.flexJustityAlignCenter,
            padding: 0,
        },
        button: {
            ...theme.custom.button,
            width: 'auto',
            margin: '50px 25px 50px 25px',
        },
    }
})

export default useStyles
